import { createRoot } from 'react-dom/client'
import { App } from './App.tsx'
import './styles.css'
// Registers our schema + context with Zero's DefaultTypes (declaration merging).
import './zero/register.ts'

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('#root not found')

// No StrictMode: it double-mounts effects, which churns the Zero websocket in dev.
createRoot(rootEl).render(<App />)
